import React from "react"

const Skew = () => {
  return (
    <div className="bg-gray-800 absolute z-0 w-full h-20 2xl:h-40 lg:h-32 transform -mt-12 2xl:-mt-20 -skew-y-2"></div>
  )
}

export default Skew
